import { useApiClient } from '../contexts/ApiContext';
import { queryKeys } from '../lib/queryClient';
import { useAuthedInfiniteQuery, useAuthedQuery } from './useAuthedQuery';

const PAGE_SIZE = 20;

export function useReferralsInfinite() {
  const apiClient = useApiClient();

  return useAuthedInfiniteQuery({
    queryKey: queryKeys.referrals(),
    queryFn: async ({ pageParam = 1 }) => {
      const response = await apiClient.api.userControllerGetReferrals({
        page: pageParam.toString(),
        limit: PAGE_SIZE.toString(),
      });
      return {
        referrals: response.referrals,
        meta: response.meta,
        page: pageParam,
        hasMore: response.meta.currentPage < response.meta.totalPages,
      };
    },
    getNextPageParam: (lastPage) => {
      if (!lastPage.hasMore) return undefined;
      return lastPage.page + 1;
    },
    initialPageParam: 1,
  });
}

export function useReferralStats() {
  const apiClient = useApiClient();

  return useAuthedQuery({
    queryKey: queryKeys.referralStats,
    queryFn: () => apiClient.api.userControllerGetReferralStats(),
  });
}
